<template>
  <section class="section hero" id="home" aria-label="hero">
    <div class="container">
      <div class="hero-content">
        <p class="section-subtitle">Welcome To Dental</p>

        <h1 class="h1 hero-title">We Are Best Dental Service</h1>

        <p class="hero-text">
          Donec vitae libero non enim placerat eleifend aliquam erat volutpat.
          Curabitur diam ex, dapibus purus sapien, cursus sed nisl tristique,
          commodo gravida lectus non.
        </p>

        <form action="" class="hero-form">
          <input
            type="email"
            name="email_address"
            aria-label="email"
            placeholder="Your Email Address..."
            required
            class="email-field"
          />

          <button type="submit" class="btn">Get Call Back</button>
        </form>
      </div>

      <figure class="hero-banner">
        <img
          src="@/assets/image/hero-banner.png"
          width="587"
          height="839"
          alt="hero banner"
          class="w-100"
        />
      </figure>
    </div>
  </section>

  <section class="section cta" aria-label="cta">
    <div class="container">
      <figure class="cta-banner">
        <img
          src="@/assets/image/cta-banner.png"
          width="1056"
          height="1076"
          loading="lazy"
          alt="cta banner"
          class="w-100"
        />
      </figure>

      <div class="cta-content">
        <p class="section-subtitle">Book Dentail Appointment</p>

        <h2 class="h2 section-title">We Are open And Welcoming Patients</h2>

        <a href="#" class="btn">Book appointment</a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HomeView",
};
</script>
